import { defineComponent as p, computed as d, openBlock as f, createElementBlock as v, normalizeClass as u, withDirectives as c, createElementVNode as l, vModelRadio as b, renderSlot as i } from "vue";
const g = ["name", "value"], y = { class: "flex items-center gap-2" }, h = /* @__PURE__ */ p({
  __name: "RadioInputBar",
  props: {
    modelValue: {},
    value: {},
    name: {}
  },
  emits: ["update:modelValue"],
  setup(m, { emit: r }) {
    const t = m, o = d({
      get: () => t.modelValue,
      set: (e) => r("update:modelValue", e)
    }), n = d(() => t.modelValue === t.value);
    return (e, a) => (f(), v("label", {
      class: u(["cursor-pointer rounded-md border px-4 py-5 text-sm hover:border-gray-300 md:text-base", {
        "!border-primary !bg-primary-50": n.value
      }])
    }, [
      c(l("input", {
        "onUpdate:modelValue": a[0] || (a[0] = (s) => o.value = s),
        type: "radio",
        name: e.name,
        autocomplete: "off",
        class: "hidden",
        value: e.value,
        onChange: a[1] || (a[1] = (s) => r("update:modelValue", e.value))
      }, null, 40, g), [
        [b, o.value]
      ]),
      l("div", y, [
        l("span", {
          class: u(["relative inline-block size-5 rounded-full border bg-white after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1/2 after:-translate-y-1/2 after:scale-0 after:rounded-full after:transition-all after:duration-300 after:content-['']", {
            "!border-primary !bg-primary after:scale-100 after:bg-white": n.value
          }])
        }, null, 2),
        i(e.$slots, "label")
      ]),
      i(e.$slots, "default")
    ], 2));
  }
});
export {
  h as _
};
